import LoginSignupButtons from "@/components/ui/LoginSignupButtons/LoginSignupButtons";
import React from "react";
import s from "./FadeCatalog.module.scss";

export default function FadeCatalog() {
  return (
    <div className={s.login_signup_buttons_container}>
      <LoginSignupButtons text={"Accedi o iscriviti per avere accesso al catalogo completo"} />
    </div>
  );
}
